"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertor = exports.taskFromOperationNode = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const uiNodes_1 = require("../../uiNodes");
const types_1 = require("./types");
const taskToOperationNode = (task) => {
    const { srcArtifactSlug: _unused2, ...nodeConfiguration } = task;
    const tapeBuilderNodeId = (0, uuid_1.v4)();
    const operationNode = {
        metadata: {
            tapeBuilderNodeId,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: nodeConfiguration,
    };
    return operationNode;
};
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    const { configuration } = operationNode;
    (0, common_1.finleyAssert)(srcNodes.length === 1, `edit node has [${srcNodes.length}] src node`);
    const srcNode = srcNodes[0];
    const uiNode = (0, uiNodes_1.getUINodeByType)(srcNode.metadata.tapeBuilderNodeType);
    (0, common_1.finleyAssert)(!uiNode.isOperation, 'src node is an operation node');
    const srcArtifactSlug = uiNode.getArtifactSlug(srcNode);
    return {
        srcArtifactSlug,
        ...configuration,
    };
};
exports.taskFromOperationNode = taskFromOperationNode;
exports.convertor = {
    operation: 'preFilter',
    nodeType: types_1.nodeType,
    taskToOperationNode,
    taskFromOperationNode: exports.taskFromOperationNode,
};
//# sourceMappingURL=converter.js.map